import { Col } from "react-styled-flexboxgrid"
import { StyledComponentPropsWithRef } from "styled-components"

// react-styled-flexboxgrid doesn't export this
type ColProps = StyledComponentPropsWithRef<typeof Col>

export type GridColumnProps = {
  oneColumn: ColProps
  twoColumns: ColProps
}

export const gridColumnProps = {
  oneColumn: {
    xs: 12,
  },
  twoColumns: {
    xs: 12,
    // eslint-disable-next-line sort-keys
    md: 6,
  },
}
